import React from 'react'
import { MerchantLocationsLoader, LoaderSwitcher } from 'router/Loaders'
import Locations from 'components/Locations'

export const LocationsWrapper = () => {
  return (
    <MerchantLocationsLoader>
      {(isParentLoaded) => (
        <LoaderSwitcher isParentLoaded={isParentLoaded}>
          <Locations />
        </LoaderSwitcher>
      )}
    </MerchantLocationsLoader>
  )
}
